/**
 * Shadow Light enum
 */
 export enum ShadowLightType {
    /**直射光 */
    DirectionLight,
    /**聚光 */
    SpotLight,
    /**点光 */
    PointLight
}